webpackJsonp([85322809437950],{

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _pragmaticForms = __webpack_require__(60);
	
	var _formManager = __webpack_require__(106);
	
	var _dropZone = __webpack_require__(169);
	
	var _link = __webpack_require__(9);
	
	var _headerManager = __webpack_require__(31);
	
	var _detail = __webpack_require__(262);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Gatsby requires a specific export format on Templates.
	var EmploymentSubmitPage = function (_React$PureComponent) {
		_inherits(EmploymentSubmitPage, _React$PureComponent);
	
		function EmploymentSubmitPage() {
			var _this2 = this;
	
			_classCallCheck(this, EmploymentSubmitPage);
	
			var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this));
	
			_this.componentDidMount = function () {
				_headerManager.HeaderManager.headerProperties = {};
			};
	
			_this.EmploymentSubmitForm = (0, _pragmaticForms.configureForm)({
				initFields: function initFields() {
					return {
						'form-name': 'submit-employment-opportunity',
						botField: '',
						jobPosition: '',
						employer: '',
						logo: null,
						location: '',
						hoursPerWeek: '',
						aboutTheRole: '',
						linkToEmploymentPositionPage: '',
						recruitmentClosingDate: '',
						flyer: null,
						firstName: '',
						lastName: '',
						email: '',
						phoneNumberPrefix: '+61',
						phoneNumber: ''
					};
				},
				validate: function validate(_ref) {
					var jobPosition = _ref.jobPosition,
					    employer = _ref.employer,
					    location = _ref.location,
					    hoursPerWeek = _ref.hoursPerWeek,
					    linkToEmploymentPositionPage = _ref.linkToEmploymentPositionPage,
					    recruitmentClosingDate = _ref.recruitmentClosingDate,
					    firstName = _ref.firstName,
					    lastName = _ref.lastName,
					    email = _ref.email,
					    phoneNumberPrefix = _ref.phoneNumberPrefix,
					    phoneNumber = _ref.phoneNumber;
	
					var errors = {};
	
					if (!jobPosition) errors.jobPosition = 'Please enter a Job Position';
					if (!employer) errors.employer = 'Please enter an employer';
					if (!location) errors.location = 'Please enter a location';
					if (!hoursPerWeek) errors.hoursPerWeek = 'Please enter hours per week';
					if (!linkToEmploymentPositionPage) errors.linkToEmploymentPositionPage = 'Please a link to the employment position page';
					if (!recruitmentClosingDate) errors.recruitmentClosingDate = 'Please enter Closing Date for Recruitment';
					if (!firstName) errors.firstName = 'Please enter your First Name';
					if (!lastName) errors.lastName = 'Please enter your Last Name';
					if (!email) errors.email = 'Please enter an Email Address';
					if (!phoneNumberPrefix) errors.phoneNumberPrefix = 'Please enter a phone prefix';
					if (!phoneNumber) errors.phoneNumber = 'Please enter a phone number';
	
					return errors;
				},
				submit: function () {
					var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
						return regeneratorRuntime.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										_context.prev = 0;
										_context.next = 3;
										return fetch('/', {
											method: 'POST',
											body: (0, _formManager.encode)(formData)
										});
	
									case 3:
	
										_this.setState({ hasSubmitted: true });
										_context.next = 9;
										break;
	
									case 6:
										_context.prev = 6;
										_context.t0 = _context['catch'](0);
	
										console.error(_context.t0);
	
									case 9:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, _this2, [[0, 6]]);
					}));
	
					return function submit(_x) {
						return _ref2.apply(this, arguments);
					};
				}()
			})(function (_ref3) {
				var form = _ref3.form;
				return _react2.default.createElement(
					form.Form,
					{ netlify: 'true', name: 'submit-employment-opportunity', 'netlify-honeypot': 'botField' },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.formSection.wrapper },
						_react2.default.createElement(
							'p',
							{ style: { display: 'none' } },
							_react2.default.createElement(
								'label',
								null,
								'Don\u2019t fill this out if you\'re human:',
								_react2.default.createElement('input', form.getInputProps({ name: 'botField', type: 'text' }))
							)
						),
						_react2.default.createElement(
							'div',
							{ 'aria-live': 'assertive' },
							form.submitError && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationMessage },
								'Error: ',
								form.submitError
							),
							form.hasErrors && _react2.default.createElement(
								'ul',
								{ className: _globalStyles.formSection.validationSummary },
								Object.keys(form.errors).map(function (key) {
									return _react2.default.createElement(
										'li',
										{ key: key, className: _globalStyles.formSection.validationMessage },
										'' + form.errors[key]
									);
								})
							)
						),
						_react2.default.createElement(
							'fieldset',
							{ className: _globalStyles.formSection.fieldset },
							_react2.default.createElement(
								'legend',
								null,
								'About the position'
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['jobPosition'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['jobPosition']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'jobPosition' },
									'Job Position / Title'
								),
								_react2.default.createElement('input', _extends({
									id: 'jobPosition'
								}, form.getInputProps({ name: 'jobPosition', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['employer'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['employer']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'employer' },
									'Employer'
								),
								_react2.default.createElement('input', _extends({ id: 'employer' }, form.getInputProps({ name: 'employer', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								_react2.default.createElement(
									_dropZone.DropZone,
									_extends({
										className: _globalStyles.formSection.dropZoneField.default
									}, form.getInputProps({ name: 'logo', type: 'file' })),
									function (file, clearFile) {
										if (file) {
											return _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'button',
													{ onClick: clearFile },
													'Clear'
												),
												_react2.default.createElement(
													'span',
													null,
													file.name
												)
											);
										} else {
											return _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													null,
													'Drop your company logo here or'
												),
												_react2.default.createElement(
													'span',
													{ className: (0, _globalStyles.button)(_globalStyles.aqua) },
													'Choose a file to upload'
												)
											);
										}
									}
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['location'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['location']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'location' },
									'Location'
								),
								_react2.default.createElement('input', _extends({ id: 'location' }, form.getInputProps({ name: 'location', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['hoursPerWeek'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['hoursPerWeek']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'hoursPerWeek' },
									'Hours per week'
								),
								_react2.default.createElement('input', _extends({
									id: 'hoursPerWeek'
								}, form.getInputProps({ name: 'hoursPerWeek', type: 'number' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								_react2.default.createElement(
									'label',
									{ htmlFor: 'aboutTheRole' },
									'About the Role (optional)'
								),
								_react2.default.createElement('textarea', _extends({
									id: 'aboutTheRole',
									className: _detail.messageTextareaStyle
								}, form.getInputProps({ name: 'aboutTheRole' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								_react2.default.createElement(
									'label',
									{ htmlFor: 'selectionCriteria' },
									'Selection Criteria (optional)'
								),
								_react2.default.createElement('textarea', _extends({
									id: 'selectionCriteria',
									className: _detail.messageTextareaStyle
								}, form.getInputProps({ name: 'selectionCriteria' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['linkToEmploymentPositionPage'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['linkToEmploymentPositionPage']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'linkToEmploymentPositionPage' },
									'Link to employment position page'
								),
								_react2.default.createElement('input', _extends({
									id: 'linkToEmploymentPositionPage'
								}, form.getInputProps({ name: 'linkToEmploymentPositionPage', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['recruitmentClosingDate'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['recruitmentClosingDate']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'recruitmentClosingDate' },
									'Application closing date'
								),
								_react2.default.createElement('input', _extends({
									id: 'recruitmentClosingDate',
									placeholder: 'dd/mm/yyyy'
								}, form.getInputProps({ name: 'recruitmentClosingDate', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								_react2.default.createElement(
									_dropZone.DropZone,
									_extends({
										className: _globalStyles.formSection.dropZoneField.default
									}, form.getInputProps({ name: 'flyer', type: 'file' })),
									function (file, clearFile) {
										if (file) {
											return _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'button',
													{ onClick: clearFile },
													'Clear'
												),
												_react2.default.createElement(
													'span',
													null,
													file.name
												)
											);
										} else {
											return _react2.default.createElement(
												'p',
												null,
												_react2.default.createElement(
													'span',
													null,
													'Drop detailed flyer, PDF, position description files here or'
												),
												_react2.default.createElement(
													'span',
													{ className: (0, _globalStyles.button)(_globalStyles.aqua) },
													'Choose a file to upload'
												)
											);
										}
									}
								)
							)
						),
						_react2.default.createElement(
							'fieldset',
							{ className: _globalStyles.formSection.fieldset },
							_react2.default.createElement(
								'legend',
								null,
								'Contact'
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.halfWidthWrapper },
								_react2.default.createElement(
									'div',
									{ className: _globalStyles.formSection.field },
									form.errors['firstName'] && _react2.default.createElement(
										'p',
										{ className: _globalStyles.formSection.validationFieldMessage },
										form.errors['firstName']
									),
									_react2.default.createElement(
										'label',
										{ htmlFor: 'firstName' },
										'First Name'
									),
									_react2.default.createElement('input', _extends({ id: 'firstName' }, form.getInputProps({ name: 'firstName', type: 'text' })))
								),
								_react2.default.createElement(
									'div',
									{ className: _globalStyles.formSection.field },
									form.errors['lastName'] && _react2.default.createElement(
										'p',
										{ className: _globalStyles.formSection.validationFieldMessage },
										form.errors['lastName']
									),
									_react2.default.createElement(
										'label',
										{ htmlFor: 'lastName' },
										'Last Name'
									),
									_react2.default.createElement('input', _extends({ id: 'lastName' }, form.getInputProps({ name: 'lastName', type: 'text' })))
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['email'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['email']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'email' },
									'Email Address'
								),
								_react2.default.createElement('input', _extends({ id: 'email' }, form.getInputProps({ name: 'email', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.phoneField },
								form.errors['phoneNumberPrefix'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['phoneNumberPrefix']
								),
								form.errors['phoneNumber'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['phoneNumber']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'phoneNumberPrefix' },
									'Phone Number'
								),
								_react2.default.createElement(
									'select',
									_extends({
										id: 'phoneNumberPrefix',
										name: 'phoneNumberPrefix'
									}, form.getInputProps({ name: 'phoneNumberPrefix', type: 'text' })),
									_react2.default.createElement(
										'option',
										{ value: '+61' },
										'+61'
									)
								),
								_react2.default.createElement('input', _extends({
									id: 'phoneNumber'
								}, form.getInputProps({ name: 'phoneNumber', type: 'text' })))
							)
						),
						_react2.default.createElement(
							'button',
							{
								className: _globalStyles.formSection.submitButton,
								type: 'submit',
								disabled: form.hasErrors || form.isLoading
							},
							'Submit Listing'
						)
					)
				);
			});
	
			_this.state = { hasSubmitted: false };
			return _this;
		}
	
		EmploymentSubmitPage.prototype.render = function render() {
			return _react2.default.createElement(
				'section',
				{ className: (0, _detail.wrapperStyle)(this.state.hasSubmitted) },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'Employment' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'Advertise Employment Opportunity' }),
					_react2.default.createElement('meta', { name: 'description', content: 'Please complete the form to submit your ad to our listing.' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'Please complete the form to submit your ad to our listing.' })
				),
				_react2.default.createElement(
					'div',
					{ className: _detail.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.detailSideBarLayout.wrapper },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.detailSideBarLayout.leftSide },
							_react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.contentSection)('#fff') },
								!this.state.hasSubmitted && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'h1',
										{ className: _detail.titleStyle },
										'Advertise Employment Opportunity'
									),
									_react2.default.createElement(
										'div',
										{ className: _detail.bodyStyle },
										_react2.default.createElement(
											'p',
											null,
											'Please complete the form below to submit your ad to our listing.'
										)
									),
									_react2.default.createElement(this.EmploymentSubmitForm, null)
								),
								this.state.hasSubmitted && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'h1',
										{ className: _detail.titleStyle },
										'Thank you for submitting your employment advertisement.'
									),
									_react2.default.createElement(
										'div',
										{ className: _detail.bodyStyle },
										_react2.default.createElement(
											'p',
											null,
											'The team at InsideOut will review the employment opportunity, and if appropriate will advertise it on our website as soon as possible.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: (0, _globalStyles.contentSection)('#fff', 0) },
										_react2.default.createElement(
											_link.Link,
											{ className: (0, _globalStyles.button)(_globalStyles.pink), to: '/get-involved' },
											'Go to Get Involved'
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return EmploymentSubmitPage;
	}(_react2.default.PureComponent);
	
	exports.default = EmploymentSubmitPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-employment-submit-index-js-132068ba09af668a4bd5.js